import React from 'react';
import styled from 'styled-components';
import { getBreakpointFromProps } from './utils';
import { Breakpoint, MediaProps } from './types';
import { breakpoints } from './constants';

const HideAboveWrapper = styled.div<{
    breakpoint: Breakpoint;
}>`
    display: none;

    @media (max-width: ${({ breakpoint }) => breakpoints[breakpoint]}px) {
        display: block;
    }
`;

const HideAbove = (props: MediaProps & { children?: React.ReactNode }) => {
    const { children } = props;

    return (
        <HideAboveWrapper breakpoint={getBreakpointFromProps(props)}>
            {children}
        </HideAboveWrapper>
    );
};

export default HideAbove;
